<!-- Read-only preview. Clicking anywhere (or the expand button) opens the
     universal pop-out editor. Angular sanitizes [innerHTML] by default. -->
<div
  class="rich-text-preview"
  [class.invalid]="invalid"
  [class.disabled]="disabled"
  role="button"
  tabindex="0"
  (mouseenter)="onPreviewIntent()"
  (focusin)="onPreviewIntent()"
  (mousedown)="onPreviewPointerDown(scroll)"
  (click)="onPreviewClick(scroll)"
  (keydown.enter)="open()"
  (keydown.space)="open()"
>
  <button
    type="button"
    class="rich-text-expand"
    [disabled]="disabled"
    (click)="$event.stopPropagation(); open()"
    aria-label="Open editor"
    title="Open editor"
  >
    <i class="pi pi-window-maximize"></i>
  </button>

  <!-- Fixed-height, manually-resizable scroll area. Kept separate from the outer
       box so the absolutely-positioned expand button stays pinned (it would
       otherwise scroll away with the content). -->
  <div #scroll class="rich-text-scroll">
    <!-- Sandboxed (script-free) so the editor HTML renders with full fidelity but
         can't execute scripts. `allow-same-origin` (no `allow-scripts`, so still
         script-free) lets us read the content height and size the iframe to it,
         so the pane scrolls the whole content. pointer-events:none (CSS) lets
         clicks fall through to open the editor and keeps the resize grip working. -->
    <iframe
      *ngIf="!isEmpty; else emptyState"
      #frame
      class="rich-text-frame"
      [srcdoc]="previewDoc"
      sandbox="allow-same-origin"
      tabindex="-1"
      aria-hidden="true"
      title="Content preview"
      (load)="syncFrameHeight()"
    ></iframe>
    <ng-template #emptyState>
      <span class="rich-text-placeholder">{{ placeholder }}</span>
    </ng-template>
  </div>
</div>

<app-rich-text-editor-dialog
  [(visible)]="dialogVisible"
  [title]="title"
  [html]="openingHtml"
  (save)="commit($event)"
  (cancel)="onCancel()"
></app-rich-text-editor-dialog>
